import { Config, Effect, Option } from 'effect';

import { EnvConfig } from '@vs-shop/rcprofi/config';

import { RuntimeClientConfig } from '@vs-shop/engine/runtime/RuntimeClientConfig';

const SentryDsn = Config.option(Config.URL(EnvConfig.NEXT_PUBLIC_SENTRY_DSN));

const SentryEnvironment = Config.String(EnvConfig.NEXT_PUBLIC_SENTRY_ENVIRONMENT).pipe(
  Config.withDefault('development')
);

const getSentryConfig = Effect.gen(function* () {
  const sentryDsnOption = yield* SentryDsn;
  const environment = yield* SentryEnvironment;

  const dsnConfig = Option.match(sentryDsnOption, {
    onNone: () => ({}),
    onSome: (url) => ({ dsn: url.toString() }),
  });

  return {
    ...dsnConfig,
    environment,
    // NEXT_PUBLIC_SENTRY_RELEASE is available everywhere (client + server, set in GitLab CI)
    // CI_COMMIT_SHA is only available in GitLab CI (not in Docker build)
    release: process.env.NEXT_PUBLIC_SENTRY_RELEASE ?? process.env.CI_COMMIT_SHA ?? 'dev',
  };
});

export const getSentryConfigSyncClient = () => {
  return RuntimeClientConfig.runSync(getSentryConfig);
};

export const getSentryConfigSyncServer = () => {
  // Server uses default ConfigProvider (process.env), no need for clientConfigProvider
  return Effect.runSync(getSentryConfig);
};
